import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, switchMap, take, tap } from 'rxjs/operators';
import { PpbApiService } from '../../ppb/shared/services/ppb-api.service';
import { UserService } from '../../ppb/shared/services/user.service';
import { ServerConfigModel } from '../../technical/version/server-config.model';
import { AccessToken } from '../models/auth-token.model';

/**
 * Temporary used in app.module.ts to load dictonary when app is initialized
 *
 * @param provider Dictionary service
 */
export function authProviderFactory(provider: LoadAppService): () => Promise<boolean> {
  return () => provider.load();
}

@Injectable({
  providedIn: 'root'
})
export class LoadAppService {
  constructor(private api: PpbApiService,
              private userService: UserService) {
  }

  load(): Promise<boolean> {
    return new Promise((resolve) => {
      this.userService.authCredentials$
        .pipe(
          take(1),
          switchMap((accessToken: AccessToken) =>
            forkJoin({
              accessToken: of(accessToken),
              keycloakURI: this.loadKeycloakURI()
            }),
          ),
          switchMap(this.userService.handleLoadToken),
          catchError(this.userService.logOut)
        )
        .subscribe(() => {
          resolve(true);
        });
    })
  }

  setKeyCloakURI(serverConfig: ServerConfigModel): void {
    const uri = serverConfig.authorizationServer.url;
    const realm = serverConfig.authorizationServer.realm;
    this.userService.keyCloakURI = `${uri}/realms/${realm}/protocol/openid-connect`;
  }

  private loadKeycloakURI = (): Observable<ServerConfigModel> => {
    return this.api.getPublic<ServerConfigModel>('/api/v1/configuration')
      .pipe(
        tap(((config: ServerConfigModel) => {
          this.setKeyCloakURI(config);
        }))
      );
  };
}
